<app-title-pages-component
  class="page-results-title-movil"
  [pageData]="pageData()">
</app-title-pages-component>

<div class="filtros-container">
  @if (isAdmin && clientOptions.length > 0) {
    <div class="filtros-clientes">
      <app-cliente-select
        [options]="clientOptions"
        [selected]="selectedClientOption"
        (selectionChange)="onClientSelect($event)"
        placeholder="Seleccionar cliente">
      </app-cliente-select>
    </div>

    @if (selectedClientOption) {
      <div class="filtros-campania">
        <app-campana-select
          [options]="campaignOptions"
          [selected]="selectedCampaignOption"
          (selectionChange)="onCampaignSelect($event)"
          placeholder="Seleccionar campaña">
        </app-campana-select>
      </div>
    }
  } @else {
    <div class="filtros-campania inline-row">
      <app-campana-select
        [options]="campaignOptions"
        [selected]="selectedCampaignOption"
        (selectionChange)="onCampaignSelect($event)"
        placeholder="Seleccione una campaña">
      </app-campana-select>
    </div>
  }
</div>

@if (selectedCampaignOption) {
  <p class="total">
    {{ resultsContent()?.responsesSubtitle }}
    <strong>{{ totalElements }}</strong>
  </p>

  @if (totalElements > 0) {
    <h2 class="section-heading">{{ resultsContent()?.responsesTitle }}</h2>

    <app-results-table
      [title]="'{{ resultsContent()?.resultsTableTitle }}'"
      [data]="resultados"
      (view)="viewResults($event)">
    </app-results-table>

    <!-- Controles de paginación -->
    @if (totalElements > 0) {
      <div class="pagination-footer">
        <div class="page-size-group">
          <label for="pageSize">Por página</label>
          <select id="pageSize" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
            @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{ size }}</option>
            }
          </select>
        </div>

        <span class="pagination-info">{{ paginationLabel }}</span>

        <div class="pagination-buttons">
          <button (click)="prevPage()" [disabled]="currentPage === 0">
            <img [src]="tablePreviousIcon()?.path ?? ''" [alt]="tablePreviousIcon()?.alt ?? ''">
          </button>
          <button (click)="nextPage()" [disabled]="currentPage >= totalPages - 1">
            <img [src]="tableNextIcon()?.path ?? ''" [alt]="tableNextIcon()?.alt ?? ''">
          </button>
        </div>
      </div>
    }
  } @else {
    <app-empty-state [message]="resultsContent()?.noSurveysMessage"></app-empty-state>
  }
} @else {
  <app-empty-state [message]="isAdmin
    ? resultsContent()?.chooseClientAndCampaignLabel
    : resultsContent()?.chooseCampaignLabel
  "></app-empty-state>
}
